import { render, staticRenderFns } from "./PrincipalPage.vue?vue&type=template&id=b370dc42&scoped=true"
import script from "./PrincipalPage.vue?vue&type=script&lang=js"
export * from "./PrincipalPage.vue?vue&type=script&lang=js"
import style0 from "./PrincipalPage.vue?vue&type=style&index=0&id=b370dc42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b370dc42",
  null
  
)

export default component.exports